<template>
  <span :class="cn(badgeVariants({ variant }), props.class)">
    <slot />
  </span>
</template>

<script setup>
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default:     'bg-primary/10 text-primary',
        secondary:   'bg-secondary text-secondary-foreground',
        success:     'bg-emerald-50 text-emerald-700',
        warning:     'bg-amber-50 text-amber-700',
        destructive: 'bg-red-50 text-red-700',
        outline:     'border border-border text-foreground',
        muted:       'bg-muted text-muted-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

const props = defineProps({
  variant: { type: String, default: 'default' },
  class:   { type: String, default: '' },
})
</script>
